import React from 'react';
import Navigation from './routes/Navigation';

export default function App() {
  return (
    <Navigation />
  );
};